import { render, staticRenderFns } from "./VoidLabelConfirmationDialog.vue?vue&type=template&id=abc8f95e&scoped=true"
import script from "./VoidLabelConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./VoidLabelConfirmationDialog.vue?vue&type=script&lang=ts"
import style0 from "./VoidLabelConfirmationDialog.vue?vue&type=style&index=0&id=abc8f95e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc8f95e",
  null
  
)

export default component.exports